<template>
<!--    <div class="col-lg-8 offset-lg-4 padding-less img order-1 jarallax" data-jarallax data-speed="0.5" style="background-image:url('/assets/images/user/03.jpg')"></div>&lt;!&ndash; end col &ndash;&gt;-->

    <section class="bg-auth-home d-table w-100">
        <div class="container">
            <div class="row align-items-center">
                <div class="col-lg-7 col-md-6">
                    <div class="me-lg-5">
                        <img src="/assets/images/user/login.svg" class="img-fluid d-block mx-auto" alt="">
                    </div>
                </div>
                <div class="col-lg-5 col-md-6">
                    <div class="card shadow rounded border-0">
                        <div class="card-body">
                            <h4 class="card-title text-center">Login</h4>
                            <form class="login-form mt-4" @submit.prevent="login()">
                                <div v-if="error !== null" class="alert alert-danger alert-dismissible fade show" role="alert">
                                    <button type="button" class="btn-close" data-bs-dismiss="alert" aria-label="Close" @click="error = null"></button>
                                    <strong>{{error}}</strong>
                                </div>

                                <div class="row">
                                    <div class="col-md-12">
                                        <div class="mb-3">
                                            <label class="form-label">email</label>
                                            <div class="form-icon position-relative">
                                                <i data-feather="mail" class="fea icon-sm icons"></i>
                                                <input type="email" class="form-control ps-5" id="login-email" placeholder=""
                                                       aria-label="enail" aria-describedby="email" v-model="user.email" required="">
                                            </div>
                                        </div>
                                    </div><!--end col-->

                                    <div class="col-md-12">
                                        <div class="mb-3">
                                            <label class="form-label">Password</label>
                                            <div class="form-icon position-relative">
                                                <i data-feather="key" class="fea icon-sm icons"></i>
                                                <input type="password" class="form-control ps-5" id="login-password"
                                                       aria-label="password" aria-describedby="password" v-model="user.password" required="">
                                            </div>
                                        </div>
                                    </div><!--end col-->

                                    <div class="col-md-12">
                                        <div class="mb-3">
                                            <label class="form-label">
                                                <router-link :to="{ name:'password.email'}" class="forgot-password">
                                                    Forgot Password?
                                                </router-link>
                                            </label>
                                        </div>
                                    </div><!--end col-->

                                    <div class="col-md-12">
                                        <div class="d-grid">
                                            <button class="btn btn-primary" type="submit">Log In</button>
                                        </div>
                                    </div><!--end col-->

                                    <div class="col-lg-12 mt-4 text-center">
                                        <router-link :to="{ name:'register'}" class="btn btn-secondary">
                                            Sign Up
                                        </router-link>
                                    </div><!--end col-->
                                </div><!--end row-->
                            </form>
                        </div>
                    </div>
                </div> <!--end col-->
            </div><!--end row-->
        </div> <!--end container-->
    </section><!--end section-->

<!--        <div v-if="error !== null" class="alert alert-danger alert-dismissible fade show" :class="{ 'show' : error !== null }" role="alert">-->
<!--            <button type="button" class="btn-close" data-bs-dismiss="alert" aria-label="Close" @click="error = null"></button>-->
<!--            <strong>{{error}}</strong>-->
<!--        </div>-->
<!--        <form class="row g-4" @submit.prevent="login()">-->
<!--            <span class="ec-login-wrap">-->
<!--                <label>Phone number</label>-->
<!--                <input type="tel" class="form-control" id="login-mobile" placeholder="5×××××"-->
<!--                       aria-label="phone" aria-describedby="phone" v-model="user.mobile" dir="ltr">-->
<!--            </span>-->

<!--            <span class="ec-login-wrap">-->
<!--                <label>Password</label>-->
<!--                <input type="password" class="form-control" id="login-password"-->
<!--                       aria-label="password" aria-describedby="password"  v-model="user.password" autocomplete="password">-->
<!--            </span>-->

<!--            <span class="ec-login-wrap ec-login-fp">-->
<!--                <label>-->
<!--                    <router-link :to="{ name:'password.email'}"  class="forgot-password">-->
<!--                        Forgot Password?-->
<!--                    </router-link>-->
<!--                </label>-->
<!--            </span>-->

<!--            <span class="ec-login-wrap ec-login-btn">-->
<!--                <button class="btn btn-primary" type="submit">-->
<!--                    Log In-->
<!--                </button>-->
<!--                <router-link :to="{ name:'register'}" class="btn btn-secondary">-->
<!--                    Sign Up-->
<!--                </router-link>-->
<!--            </span>-->
<!--        </form>-->
<!--    </div>-->
</template>

<script>
import { useToast } from "vue-toastification";
const toast = useToast();
export default {
    inject: ['auth'],
    props :['main'],
    data() {
        return {
            user: {},
            error: null,
        }
    },
    watch: {
        '$userLoggedIn.value': function (newVal) {
            if(newVal === true){
                this.$router.push({name: 'home',  });
            }
        },
    },
    methods: {
        login() {
            const  that = this;

            const id = toast.success( 'Signing in.', {
                timeout: 2000
            });

            this.auth.login({
                'data' : this.user,
                'on_success' : function (response){
                    toast.success( 'Welcome back again.', {
                        timeout: 2000
                    });
                    // that.error = null;
                    // that.$router.push({name: 'home'});
                },
                'on_fail' : function (message){
                    that.error = message;
                },
                'on_completed' : function (){
                    toast.dismiss(id);
                }
            });

        }
    },
}
</script>
